export const SourceAircraftType = "AircraftTypes";

export const TitleAircraftType = {
  list: "Aircraft Type List",
  edit: "Edit Aircraft Type",
  create: "Create Aircraft Type",
};
